import React, { useState, useEffect } from 'react';
import { Typography, CircularProgress, Alert, List, ListItem, ListItemText, Paper, Button, Box, Divider, Grid, Card, CardActionArea, CardContent, Chip, FormControlLabel, Switch } from '@mui/material';
import { getConfigurations } from '../api/api';
import DiagramView from '../components/DiagramView';

const Configuration = () => {
  const [configurations, setConfigurations] = useState([]);
  const [selectedConfig, setSelectedConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [diagramView, setDiagramView] = useState(false);

  useEffect(() => {
    const fetchConfigurations = async () => {
      try {
        setLoading(true);
        const data = await getConfigurations();
        setConfigurations(data);
        setError(null);
      } catch (err) {
        setError('Error al cargar las configuraciones. Asegúrese de que el backend está en ejecución.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchConfigurations();
  }, []);

  const handleSelectConfig = (config) => {
    setSelectedConfig(config);
  };

  const handleBackToList = () => {
    setSelectedConfig(null);
  };

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  if (selectedConfig) {
    return (
      <Paper sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Button onClick={handleBackToList}>
            &larr; Volver a la lista
          </Button>
          <FormControlLabel
            control={<Switch checked={diagramView} onChange={() => setDiagramView(!diagramView)} />}
            label="Vista de Diagrama"
          />
        </Box>
        <Typography variant="h5" gutterBottom>
          Detalle de: {selectedConfig.name}
        </Typography>
        
        {diagramView ? (
          <Box sx={{ height: 600, width: '100%', overflow: 'hidden', mt: 2, border: '1px solid #444' }}>
            <DiagramView data={selectedConfig} />
          </Box>
        ) : (
          <>
            <Box sx={{ my: 2 }}>
                <Typography variant="h6">Credenciales</Typography>
                <List dense>
                    {selectedConfig.credentials.map(cred => (
                        <ListItem key={cred.code}>
                            <ListItemText primary={cred.name} secondary={`Código: ${cred.code}`} />
                        </ListItem>
                    ))}
                </List>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Box sx={{ my: 2 }}>
                <Typography variant="h6">Tipos de Mensajes de Evento</Typography>
                <List dense>
                    {selectedConfig.event_message_types.map(emt => (
                        <ListItem key={emt.id}>
                            <ListItemText 
                                primary={emt.event_type_code} 
                                secondary={`De: ${emt.source_credential} → A: ${emt.destination_credential || 'N/A'}`} 
                            />
                        </ListItem>
                    ))}
                </List>
            </Box>
          </>
        )}
      </Paper>
    );
  }

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        Configuraciones del Sistema
      </Typography>
      <Grid container spacing={3}>
        {configurations.map((config) => (
          <Grid item xs={12} sm={6} md={4} key={config.name}>
            <CardActionArea component="div" onClick={() => handleSelectConfig(config)} sx={{ height: '100%' }}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" component="h2" gutterBottom>
                    {config.name}
                  </Typography>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                      Credenciales:
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {config.credentials.map((cred) => (
                        <Chip key={cred.code} label={cred.name} size="small" />
                      ))}
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </CardActionArea>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Configuration;